import { useEffect } from 'react';
import { useLocation } from '@/lib/router-compat';

/**
 * Only the public marketing/intake pages should ever be indexed.
 * Everything else (sign-in, recovery, dashboards, admin tools) gets a
 * hard noindex so it can never surface in a search result.
 */
const INDEXABLE_ROUTES = ['/', '/intake', '/louisiana-technology-office'];

const SearchIndexingControl = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const indexable = INDEXABLE_ROUTES.includes(pathname);
    let tag = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null;

    if (indexable) {
      tag?.remove();
      return;
    }

    if (!tag) {
      tag = document.createElement('meta');
      tag.name = 'robots';
      document.head.appendChild(tag);
    }
    tag.content = 'noindex, nofollow, noarchive, nosnippet';
  }, [pathname]);

  return null;
};

export default SearchIndexingControl;
